<template>
    <div class="language-selector">
        <select
            class="form-select form-select-sm w-auto shadow-sm"
            v-model="selectedLanguage"
            @change="changeLanguage">
            <option v-for="lang in languages" :key="lang.code" :value="lang.code">
                {{ lang.name }}
            </option>
        </select>
    </div>
</template>

<script>
import axios from "axios"; 
import { changeLanguage } from '@/i18n';
export default {
  data() {
    return {
        languages: [],
        selectedLanguage: localStorage.getItem('locale') || this.$i18n.locale || 'en'
    };
  },
  methods: {
    async changeLanguage() {
      await changeLanguage(this.selectedLanguage);
    },   
    getSupportedLanguages(){
      axios.post('/api/translations/languages', {}, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
          this.languages = response.data;
        }
      })
      .catch(function (error) {
         console.error(error);
      });
    }
  },
  created() {
    this.getSupportedLanguages();
  }
};
</script>
